import {
  getIntegrationAction,
  getIntegrationFailAction,
  getIntegrationSuccessAction,
} from '../integrations.actions';
import { IntegrationDetails } from '../interfaces';
import { createReducer, Action, on } from '@ngrx/store';

export interface State extends Partial<IntegrationDetails> {
  isLoading: boolean;
}

export const initialState: State = {
  isLoading: false,
};

const integrationReducer = createReducer(
  initialState,
  on(getIntegrationAction, () => ({ isLoading: true })),
  on(getIntegrationSuccessAction, (_, action) => ({
    isLoading: false,
    ...action.integration,
  })),
  on(getIntegrationFailAction, () => ({ isLoading: false })),
);

export function reducer(state: State | undefined, action: Action) {
  return integrationReducer(state, action);
}
